import styles from './invictustest.module.css'
import { getExamType } from 'utils/common'

const InvictusEliteProgram = () => {
    const examType =getExamType();
    function applyprocess()
    {
        window.webengage.track(examType+'_apply_for_selection', {
            exam_type:examType,
            page_url:window.location.href,
            "utm parameters":localStorage.getItem("utmParams")?localStorage.getItem("utmParams"):""
        })
    }
    
    return (
        <div>
            {/* jee advanced elite start */}
            <div className="container p-lg-2 pe-3 ps-3">
                <div className={`${styles.jee_advanced_elite}`}>
                    <div className={`${styles.jee_elite_content}`}>
                        <h4>JEE Advanced Elite Program</h4>
                        <p>
                            Only for the Most Dedicated for IIT’s
                        </p>
                        <div className={`${styles.grey_box_jee}`}>
                            <p>Not Just Another Course – A Challenge!<br />Limited Seats – Only the Best Get In!</p>
                        </div>
                    </div>
                    <div className={`${styles.admiss_info}`}>
                        <p>🚨 Admissions Closing Soon!</p>
                        <div className={`${styles.selection_box}`}> <a href="#isregister" onClick={applyprocess} className={`${styles.apply_process_btn}`}>Apply for Selection Process</a> </div>
                    </div>
                </div>
            </div>
            {/* jee advanced elite end */}
        </div>
    )
}

export default InvictusEliteProgram